export default __webpack_public_path__ + "static/media/savingsrug.9740fe17.jpg";